export default __webpack_public_path__ + "static/media/KNS-icon.781c7cef.png";